import React from "react";
import ParentComponent from "../../../lib/ParentComponent";
import { AuthContext } from "../../../lib/AuthContext";
import Utils from "../../../Utils";
import ar from "../../../locale";
import { title } from "../../../constants";
import firebase from "../../../lib/firebase";
import moment from "moment";
import "moment/locale/ar";

export default class FormationComments extends ParentComponent {
  static contextType = AuthContext;

  constructor(props, context) {
    super(props, context);
    this.state = {
      user: context.user,
      comments: [],
      deleting: {},
    };
    this.clubKey = this.props.match.params.clubkey;
    this.formationKey = this.props.match.params.key;
    this.formationCommentPath =
      "comments/clubs_formations/" +
      this.clubKey +
      "/" +
      this.formationKey +
      "/";
    this.formationCommentRef = firebase
      .database()
      .ref(this.formationCommentPath);
    this.formationRef = firebase
      .database()
      .ref("clubs_formations/" + this.clubKey + "/" + this.formationKey + "/");
  }

  componentDidMount() {
    super.componentDidMount();
    document.title = title;
    this.formationCommentRef.on("value", (response) => {
      this.state.comments = Utils.convertToArrayWithInsertionOrder(
        response.val()
      );
      this.updateState();
    });
    window.Tablesaw.init(this.$("#sawtable"));
  }

  componentWillUnmount() {}

  updateState = () => {
    this.setState((prev) => {
      return { ...prev };
    });
  };

  deleteConfirmation = (comment) => {
    this.confirm(null, this.deleteComment.bind(this, comment));
  };

  deleteComment = (comment) => {
    this.state.deleting[comment.key] = true;
    this.updateState();
    this.formationCommentRef
      .child(comment.key)
      .remove()
      .then(() => this.updateCommentCount())
      .then(() => {
        this.updateState();
      })
      .catch((error) => {
        this.state.deleting[comment.key] = false;
        this.showError(error.message);
        this.updateState();
      });
  };

  updateCommentCount = () => {
    return this.formationRef.child("comments").transaction((comments) => {
      comments = comments || 0;
      if (comments > 0) {
        --comments;
      }
      return comments;
    });
  };

  renderComments = (comment, index) => {
    let on = moment(comment.timestamp);
    on.locale("ar");
    return (
      <tr key={comment.key}>
        <td className="title">
          {comment.photoUrl && (
            <img
              src={comment.photoUrl}
              alt="avatar"
              className="avatarc rounded-circle"
              width="30"
              height="30"
            />
          )}
          {!comment.photoUrl && (
            <img
              src="/assets/images/blankuser.png"
              alt="avatar"
              className="avatarc rounded-circle"
              width="30"
              height="30"
            />
          )}
          <span className="pl-2 pr-2">{comment.name}</span>
        </td>
        <td>{comment.text}</td>
        <td>{on.format("lll")}</td>
        <td>
          {!this.state.deleting[comment.key] && (
            <i
              className="fa fa-trash text-danger cursor-pointer"
              title={ar.delete}
              onClick={this.deleteConfirmation.bind(this, comment)}
            ></i>
          )}
          {this.state.deleting[comment.key] && (
            <span
              className="d-inline-block spinner-border spinner-border-sm text-danger"
              role="status"
            ></span>
          )}
        </td>
      </tr>
    );
  };

  render() {
    return (
      <div className="container-fluid">
        <div className="row">
          <div className="col-12">
            <div className="card no-toolbar border-0">
              <div className="card-body">
                <div className="row">
                  <div className="col-12 mt-2">
                    <h2 className="card-title">{ar.comments}</h2>
                    <h5 className="card-subtitle">
                      {ar.total} {this.state.comments.length}
                    </h5>
                  </div>
                </div>
                <table
                  id="sawtable"
                  className="mt-3 tablesaw table-bordered table-striped table-hover table no-wrap"
                  data-tablesaw-mode="swipe"
                >
                  <thead>
                    <tr>
                      <th
                        scope="col"
                        data-tablesaw-priority="2"
                        className="border"
                      >
                        {ar.name}
                      </th>
                      <th
                        scope="col"
                        data-tablesaw-sortable-col
                        data-tablesaw-priority="3"
                        className="border"
                      >
                        {ar.comments}
                      </th>
                      <th
                        scope="col"
                        data-tablesaw-priority="2"
                        className="border"
                      >
                        {ar.commented_on}
                      </th>
                      <th scope="col" className="border">
                        {ar.delete}
                      </th>
                    </tr>
                  </thead>
                  <tbody>{this.state.comments.map(this.renderComments)}</tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
